<template>
<div>
    <div v-if="fullscreenMode" class="fullscreen bg-info w-100 position-fixed">
        <div class="fs-button-group position-fixed d-flex justify-content-between my-0">
            <b-button-group>
                <b-button v-b-toggle.fs-sidebar v-b-tooltip.hover title="Afficher la liste des chapitres"><b-icon icon="layout-sidebar-inset"></b-icon> Liste des chapitres</b-button>
            </b-button-group>
            <b-button-group>
                <b-button @click="currentPage=1" :disabled="currentPage<=1"><b-icon icon="chevron-double-left"></b-icon></b-button>
                <b-button @click="previousPage" :disabled="currentPage<=1"><b-icon icon="chevron-left"></b-icon></b-button>
                <b-button disabled>{{currentPage}} / {{pageCount}}</b-button>
                <b-button @click="nextPage" :disabled="currentPage>=pageCount"><b-icon icon="chevron-right"></b-icon></b-button>
                <b-button @click="currentPage=pageCount" :disabled="currentPage>=pageCount"><b-icon icon="chevron-double-right"></b-icon></b-button>
            </b-button-group>
            <b-button-group>
                <b-button @click="fsZoom('out')" :disabled="fsWidth<=fsWidthMin"><b-icon icon="zoom-out"></b-icon></b-button>
                <b-button @click="fsZoom('in')" :disabled="fsWidth>=fsWidthMax"><b-icon icon="zoom-in"></b-icon></b-button>
            </b-button-group>
            <b-button-group>
                <b-button @click="switchFullscreenMode()" v-b-tooltip.hover title="Quitter le mode plein écran"><b-icon icon="fullscreen-exit"></b-icon></b-button>
            </b-button-group>
        </div>
        <div class="d-flex justify-content-between">

        <pdf-viewer :courseFile="course" :page="currentPage" class="mt-5 mx-auto" :style="'width:'+fsWidth+'%;'"></pdf-viewer>
        <pdf-viewer v-if="fsWidth<=50 && currentPage<pageCount" :courseFile="course" :page="currentPage+1" class="mt-5 mx-auto" :style="'width:'+fsWidth+'%;'"></pdf-viewer>
        </div>
        <b-sidebar id="fs-sidebar" :title="module.name" shadow backdrop width="500px">
            <template v-slot:header-close><b-icon-arrow-bar-left/></template>
            <b-list-group>
                <b-list-group-item variant="info">
                    <h5>Liste des chapitres</h5>
                    <span v-if="notConsulted.length>0" class="caption">L'icône <b-icon-exclamation-circle-fill variant="danger" class="rounded-circle bg-white"></b-icon-exclamation-circle-fill> désigne les chapitres que vous avez besoin de consulter avant de recommencer un exercice</span>
                </b-list-group-item>
                <template v-for="c in module.chapters">
                    <b-list-group-item variant="secondary" active-class="bg-secondary" :key="c.id" :active="activeChapters.includes(c.id)" :page="'./'+c.page_number" @click="selectPage(c.page_number)">
                        <b-icon v-if="!notValidated.includes(c.id)" icon="check-circle-fill" variant="success" class="rounded-circle bg-white"></b-icon>
                        <b-icon-exclamation-circle-fill v-else-if="notConsulted.includes(c.id)" variant="danger" class="rounded-circle bg-white"></b-icon-exclamation-circle-fill>
                        {{ c.title }}
                    </b-list-group-item>
                </template>
            </b-list-group>
        </b-sidebar>
    </div>
    <div v-else>
    <h1>Support de formation</h1>
    <h3>{{ module.name }}</h3>
    <dashboard-link-button id="db-btn"></dashboard-link-button>
    <b-card 
        header="Le cahier"
        header-bg-variant="primary"
        header-text-variant="white"
        header-tag="h4"
    >
        <b-container>
            <b-row>
                <b-col :class="'col-xs-12 col-lg-5 chapter-list'">
                    <b-list-group>
                        <b-list-group-item variant="info">
                            <h5>Liste des chapitres</h5>
                            <span v-if="notConsulted.length>0" class="caption">L'icône <b-icon-exclamation-circle-fill variant="danger" class="rounded-circle bg-white"></b-icon-exclamation-circle-fill> désigne les chapitres que vous avez besoin de consulter avant de recommencer un exercice</span>
                        </b-list-group-item>
                        <template v-for="c in module.chapters">
                            <b-list-group-item variant="secondary" active-class="bg-secondary" :key="c.id" :active="activeChapters.includes(c.id)" :page="'./'+c.page_number" @click="selectPage(c.page_number)">
                                <b-icon v-if="!notValidated.includes(c.id)" icon="check-circle-fill" variant="success" class="rounded-circle bg-white"></b-icon>
                                <b-icon-exclamation-circle-fill v-else-if="notConsulted.includes(c.id)" variant="danger" class="rounded-circle bg-white"></b-icon-exclamation-circle-fill>
                                {{ c.title }}
                            </b-list-group-item>
                        </template>
                    </b-list-group>
                </b-col>
                <b-col id="embed-view" :class="'col-xs-12 col-lg-7 booklet'">
                    <div class="d-flex">
                        <b-button-group>
                            <b-button @click="currentPage=1" :disabled="currentPage<=1"><b-icon icon="chevron-double-left"></b-icon></b-button>
                            <b-button @click="previousPage" :disabled="currentPage<=1"><b-icon icon="chevron-left"></b-icon></b-button>
                            <b-button disabled>{{currentPage}} / {{pageCount}}</b-button>
                            <b-button @click="nextPage" :disabled="currentPage>=pageCount"><b-icon icon="chevron-right"></b-icon></b-button>
                            <b-button @click="currentPage=pageCount" :disabled="currentPage>=pageCount"><b-icon icon="chevron-double-right"></b-icon></b-button>
                        </b-button-group>
                        <b-button-group class="zoom-button d-none d-lg-block">
                            <b-button @click="switchFullscreenMode()" v-b-tooltip.hover title="Afficher le cahier en plein écran"><b-icon icon="arrows-fullscreen"></b-icon></b-button>
                        </b-button-group>
                    </div>
                    <pdf-viewer :courseFile="course" :page="currentPage"></pdf-viewer>
                    <b-button-group>
                        <b-button @click="currentPage=1" :disabled="currentPage<=1"><b-icon icon="chevron-double-left"></b-icon></b-button>
                        <b-button @click="previousPage" :disabled="currentPage<=1"><b-icon icon="chevron-left"></b-icon></b-button>
                        <b-button disabled>{{currentPage}} / {{pageCount}}</b-button>
                        <b-button @click="nextPage" :disabled="currentPage>=pageCount"><b-icon icon="chevron-right"></b-icon></b-button>
                        <b-button @click="currentPage=pageCount" :disabled="currentPage>=pageCount"><b-icon icon="chevron-double-right"></b-icon></b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-container>
    </b-card>
    <!-- <b-card 
        header="La vidéo"
        header-bg-variant="primary"
        header-text-variant="white"
        header-tag="h4"
    >
        <b-embed
            type="iframe"
            aspect="16by9"
            :src="module.video_url"
            allowfullscreen
        ></b-embed>
    </b-card> -->
    </div>
</div>
</template>

<script>
import PdfViewer from '../components/PdfViewer.vue';
import DashboardLinkButton from '../components/DashboardLinkButton.vue';
import api from '@/services/api.js'

export default {
    name:"Course",
	components: {
        PdfViewer,
        DashboardLinkButton,
	},
    computed: {
        moduleId() {return parseInt(this.$route.params.moduleId)},
        notConsulted() {
            let list = []
            if(this.lastExam!=null) {
                this.lastExam.exam_data.forEach(exam_data => {
                    if (exam_data.course_consulted == false && !list.includes(exam_data.question.chapter.id)) {
                        list.push(exam_data.question.chapter.id)
                    }
                });
            }
            return list
        },
        notValidated() {
            let list = []
            if(this.lastExam!=null) {
                this.lastExam.exam_data.forEach(exam_data => {
                    if (exam_data.is_success == false && !list.includes(exam_data.question.chapter.id)) {
                        list.push(exam_data.question.chapter.id)
                    }
                });
            }
            return list
        },
        activeChapters() {
            let activeChapters = []
            this.module.chapters.forEach(chapter => {
                if (this.currentPage >= chapter.page_number && this.currentPage <= chapter.end_page) {
                    activeChapters.push(chapter.id)
                }
            })
            return activeChapters
        },
        secondFsPage() {
            return this.currentPage+1;
        }
    },
    data () {
        return {
            modulesList: {},
            module: {},
            course: '',
            lastExam: [],
            currentPage: 1,
            fullscreenMode: false,
            pageCount:0,
            fsWidth:50,
            fsWidthMin:30,
            fsWidthMax:100,
            fsWidthStep:10,
        }
    },
    methods: {
        async loadModule() {
            this.$parent.$parent.setLoading(true, "Chargement de votre support de formation");
            await api.get('/module/'+this.moduleId)
            .then(response => {
                this.course = response.data[0].course
                this.module = response.data[0].module
                this.module.chapters.sort((a, b) => {return a.page_number - b.page_number})
                this.lastExam = (response.data[0].exams[0] && response.data[0].exams[0].is_ended==true) ? response.data[0].exams[0] : (response.data[0].exams[1] && response.data[0].exams[1].is_ended==true) ? response.data[0].exams[1] : null
                this.module.chapters.forEach(chapter => {
                    if(chapter.id == this.$route.params.chapterId) {
                        this.currentPage = chapter.page_number
                        return
                    }
                })
                this.$parent.$parent.setLoading(false)
            })
            .catch(() => {
                this.$router.push({name: "Dashboard"})
            })
        },
        selectPage(page_number) {
            this.currentPage = page_number
        },
        switchFullscreenMode() {
            this.fullscreenMode = !this.fullscreenMode;
        },
        nextPage() {
            if(this.currentPage<this.pageCount) {
                this.currentPage++
            }
        },
        previousPage() {
            if(this.currentPage>1) {
                this.currentPage--
            }
        },
        fsZoom(direction) {
            switch(direction) {
                case 'in':
                    if(this.fsWidth < this.fsWidthMax) {this.fsWidth += this.fsWidthStep}
                    break
                case 'out':
                    if(this.fsWidth > this.fsWidthMin) {this.fsWidth -= this.fsWidthStep}
                    break
            }
        }
    },
    created () {
        this.loadModule()
        window.scrollTo(0,0);
    },
    watch: {
        moduleId: function() {
            this.loadModule()
        },
        currentPage() {
            this.activeChapters.forEach(chapter => {
                if (this.notConsulted.includes(chapter)) {
                    api.patch('/exam/data/'+chapter+'/edit')
                    .then(response => {
                        this.lastExam = response.data[0]
                    })
                    .catch(() => {
                    })
                }
            })
        },
    }
}

</script>

<style scoped>
h1 {
  font-weight: bold;
  margin-bottom: 20px;
}
.col {
    margin-bottom: 1rem;
}
.list-group-item {
    cursor: pointer;
}
.active {
    background-color: #003C71 !important;
    border-color: #003C71 !important;
}
.caption {
    font-size: 0.8em;
    font-style: italic
}
.chapter-list {
    margin-top: 1rem
}
#db-btn {
    margin-left: 0;
}
.zoom-button {
    position: absolute;
    right: 15px
}
.fullscreen {
    z-index: 10;
    top: 0px;
    left: 0;
    height: 100%;
    overflow-y: scroll;
    max-height: 100%;
}
#embed-view .btn-group {
    margin: 1rem auto;
}
.fs-button-group {
    z-index: 11;
    width: 100vw;
    background-color: #6b6b6b;
}
</style>